import { useService } from 'react-reservice';

import symbolsPreferenceService from './service';

export const useSymbolsPreference = () => {
  return useService(symbolsPreferenceService, (state) => state);
};

export { symbolsPreferenceService };
